//////////////////////////////////////////////////////////////////////////////
//
//  AdminActionLog API
//
//  작성자: MediInStep Team
//  생성일: 2025-12-26
//
//  설명: 관리자 액션 로그 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 관리자 액션 로그 관련 API
 */
export const AdminActionLogAPI: ApiGroup = {
    pagedList: {
        title: "관리자 액션 로그 목록 조회",
        url: "/AdminActionLog/paged-list",
        method: "POST",
        paramz: {}, // AdminActionLogCriteria fields will be passed here as Body
    },
}

export default AdminActionLogAPI
